import React from 'react';

import {LLBtn2, withCommon} from '../../components';
import {DrawerCloseButton} from '../../pages/user-profile/components';

const EasyMembershipBlocked = withCommon({
    store: ({store}) => ({
        viewSize: store.site.status.viewSize,
        closeModal: store.modal.close,
        closeDrawer: store.drawer.close,
        openChat: store.liveChat.open,
    }),
    defaultName: 'EasyMembershipBlocked',
    isObserver: true,
    isTrans: true,
})(({trans, viewSize, closeModal, closeDrawer, openChat, inDestDrawer}) => {
    const onSupport = () => {
        closeModal();
        closeDrawer();
        openChat();
    };

    const body = (
        <div className={`easy-membership-prompt easy-membership-prompt--${viewSize}`}>
            <h2 className="easy-membership-prompt__title">
                {trans('Your Identity Information Could Not Be Verified!')}
            </h2>
            <p className="easy-membership-prompt__body">
                {trans('EASY_MEMBERSHIP_BLOCK_BODY')}
            </p>
            <p className="easy-membership-prompt__body">
                {trans('EASY_MEMBERSHIP_BLOCK_SUPPORT')}
            </p>
            <LLBtn2
                customClasses={`easy-membership-prompt__cta ll-btn--accent`}
                onClick={onSupport}
            >
                {trans('CONTACT LIVE SUPPORT')}
            </LLBtn2>
        </div>
    );

    if (!inDestDrawer) {
        return body;
    }

    return (
        <div className="signup-drawer">
            {viewSize === 'desktop' ? (
                <div className="signup-drawer__header">
                    <p>{trans('Your Identity Information Could Not Be Verified!')}</p>
                    <DrawerCloseButton/>
                </div>
            ) : (
                <div className="signup__header--mobile">
                    {trans('Your Identity Information Could Not Be Verified!')}
                    <DrawerCloseButton/>
                </div>
            )}
            {body}
        </div>
    );
});

export default EasyMembershipBlocked;
